import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To specify the packages your project depends on, you must
list them as `}<inlineCode parentName="p">{`"dependencies"`}</inlineCode>{` or `}<inlineCode parentName="p">{`"devDependencies"`}</inlineCode>{` in your package's `}<a parentName="p" {...{
        "href": "creating-a-packge-json-file"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` file. When you (or another user) run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`, npm will download dependencies and devDependencies that are listed in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` that meet the `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic version`}</a>{` requirements listed for each. To see which versions of a package will be installed, use the `}<a parentName="p" {...{
        "href": "https://semver.npmjs.com/"
      }}>{`semver calculator`}</a>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`"dependencies"`}</inlineCode>{`: Packages required by your application in production.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`"devDependencies"`}</inlineCode>{`: Packages that are only needed for local development and testing.`}</li>
    </ul>
    <h2>{`Adding dependencies to a `}<inlineCode parentName="h2">{`package.json`}</inlineCode>{` file`}</h2>
    <p>{`You can add dependencies to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file from the command line or by manually editing the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <h3>{`Adding dependencies to a `}<inlineCode parentName="h3">{`package.json`}</inlineCode>{` file from the command line`}</h3>
    <p>{`To add dependencies and devDependencies to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file from the command line, you can install them in the root directory of your package using the `}<inlineCode parentName="p">{`--save-prod`}</inlineCode>{` flag for dependencies (the default behavior of `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`) or the `}<inlineCode parentName="p">{`--save-dev`}</inlineCode>{` flag for devDependencies.`}</p>
    <p>{`To add an entry to the `}<inlineCode parentName="p">{`"dependencies"`}</inlineCode>{` attribute of a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, on the command line, run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install <package-name> [--save-prod]
`}</code></pre>
    <p>{`To add an entry to the `}<inlineCode parentName="p">{`"devDependencies"`}</inlineCode>{` attribute of a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, on the command line, run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install <package-name> --save-dev
`}</code></pre>
    <h3>{`Manually editing the `}<inlineCode parentName="h3">{`package.json`}</inlineCode>{` file`}</h3>
    <p>{`To add dependencies to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, in a text editor, add an attribute called `}<inlineCode parentName="p">{`"dependencies"`}</inlineCode>{` that references the name and `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic version`}</a>{` of each dependency:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
  "name": "my_package",
  "version": "1.0.0",
  "dependencies": {
    "my_dep": "^1.0.0",
    "another_dep": "~2.2.0"
  }
}
`}</code></pre>
    <p>{`To add devDependencies to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, in a text editor, add an attribute called `}<inlineCode parentName="p">{`"devDependencies"`}</inlineCode>{` that references the name and `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic version`}</a>{` of each devDependency:`}</p>
    <pre><code parentName="pre" {...{}}>{`"name": "my_package",
"version": "1.0.0",
"dependencies": {
  "my_dep": "^1.0.0",
  "another_dep": "~2.2.0"
},
"devDependencies" : {
  "my_test_framework": "^3.1.0",
  "another_dev_dep": "1.0.0 - 1.2.0"
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      